export default __webpack_public_path__ + "static/media/fav_icon.e52ceadc.ico";